<section class="first-sold" id="first-sold" *ngIf="count > 0" [class.is-tint]="tint" [class.is-playable]="playable">
  <!-- Plain order book: partial sets, slow launches, reduced motion. -->
  <div class="wrap" *ngIf="!playable">
    <div class="first-sold-header">
      <span class="first-sold-eyebrow"><span class="ix" *ngIf="ix">{{ ix }}</span>Launch order book</span>
      <h2 class="first-sold-title">{{ heading }}</h2>
      <p class="first-sold-partial" *ngIf="isPartial">
        Showing all {{ count }} sales recorded so far. This series has fewer than 100.
      </p>
    </div>
  </div>

  <!-- Launch playback (owner's scrolly_time design): intro, the sticky stage the
       scroll drives, then the finale. -->
  <ng-container *ngIf="playable">
    <div class="sc-intro">
      <div class="sc-eyebrow"><span class="ix" *ngIf="ix">{{ ix }}</span>&#9679; Launch order book</div>
      <h2 class="sc-title">What do <em>{{ durationWords(total) }}</em> feel like?</h2>
      <p>
        That is how long the first {{ count }} plates of the {{ year }} series took to sell when DVLA opened the sale<span *ngIf="launchDate"> on {{ launchDate }}</span>.
        Scroll to feel it, second by second.
      </p>
      <div class="sc-prompt">Scroll to begin</div>
    </div>

    <div class="sc-stage" #stage [style.height.px]="stagePx">
      <div class="sc-sticky">
        <div class="sc-left">
          <div class="sc-timer-label">Time since the sale opened<span *ngIf="openClock"> &middot; {{ openClock }}</span></div>
          <div class="sc-timer" aria-hidden="true">
            <span>{{ floor(simTime / 60) }}</span><span class="sc-sep">:</span><span>{{ pad(simTime % 60) }}</span>
          </div>
          <div class="sc-counters">
            <div class="sc-counter">
              <div class="sc-counter-label">Plates sold</div>
              <div class="sc-counter-value">{{ soldCount }}<span class="sc-of">/{{ count }}</span></div>
            </div>
            <div class="sc-counter">
              <div class="sc-counter-label">Spent</div>
              <div class="sc-counter-value"><span class="sc-pre">&pound;</span>{{ spent.toLocaleString('en-GB') }}</div>
            </div>
          </div>
          <div class="sc-caption" *ngIf="caption" aria-live="polite">
            <div class="sc-caption-ctx">{{ caption.ctx }}</div>
            <div class="sc-caption-body" [innerHTML]="caption.body"></div>
          </div>
        </div>
        <div class="sc-right">
          <div class="sc-stack">
            <div class="sc-row" *ngFor="let s of stack; trackBy: trackByRank">
              <span class="sc-rank">{{ pad(s.rank) }}</span>
              <span class="sc-plate">
                <pla-plate [rawPlate]="s.plate"
                           [showPrice]="false"
                           [customClass]="'flat shaded'"
                           [smallPlate]="true"
                           [openModal]="false"
                           [clickThrough]="false"
                           [noMargin]="true"></pla-plate>
              </span>
              <span class="sc-ts">{{ clock(s.t) }}</span>
              <span class="sc-price">{{ gbp(s.price) }}</span>
            </div>
          </div>
        </div>
        <div class="sc-pace"><div class="sc-pace-fill" [style.width.%]="progress * 100"></div></div>
      </div>
    </div>

    <div class="sc-finale">
      <div class="sc-eyebrow">First {{ count }} sold<span *ngIf="lastClock"> &middot; {{ lastClock }}</span></div>
      <h2>{{ count }} plates. <em>{{ duration(total) }}.</em></h2>
      <p>{{ data.rushDuration }} from the first sale to the {{ count === 100 ? 'hundredth' : 'last' }}.</p>
      <div class="sc-anchors">
        <div class="sc-anchor">
          <div class="sc-kicker">The busiest 30 seconds</div>
          <div class="sc-anchor-body"><strong>{{ busiest(30).count }} plates</strong> sold, ending {{ clock(busiest(30).end) }} after the sale opened.</div>
        </div>
        <div class="sc-anchor" *ngIf="topSale as top">
          <div class="sc-kicker">Top price</div>
          <div class="sc-anchor-body"><strong>{{ top.plate }}</strong> went for {{ gbp(top.price) }}, plate {{ top.rank }} of {{ count }}.</div>
        </div>
        <div class="sc-anchor">
          <div class="sc-kicker">Spent</div>
          <div class="sc-anchor-body"><strong>{{ gbp(totalSpent) }}</strong> on the first {{ count }} plates, {{ gbp(round(totalSpent / count)) }} each on average.</div>
        </div>
      </div>
      <div class="sc-see-all">
        <a role="button" tabindex="0" (click)="toggleGrid()" (keydown.enter)="toggleGrid()">
          {{ showGrid ? 'Hide the list' : 'See all ' + count + ' in order' }} {{ showGrid ? '↑' : '↓' }}
        </a>
      </div>
    </div>
  </ng-container>

  <div class="wrap" *ngIf="!playable || showGrid">
    <div class="first-sold-grid" [class.after-finale]="playable">
      <div class="fs-card" *ngFor="let e of entries; let i = index">
        <span class="fs-rank">{{ i + 1 }}</span>
        <div class="fs-plate-wrap">
          <pla-plate [rawPlate]="e.plate"
                     [showPrice]="false"
                     [customClass]="'flat shaded'"
                     [xSmallPlate]="true"
                     [openModal]="false"
                     [clickThrough]="false"
                     [noMargin]="true"></pla-plate>
        </div>
        <span class="fs-price">{{ formatPrice(e.price) }}</span>
        <span class="fs-date" *ngIf="dateStamp(e)">{{ dateStamp(e) }}</span>
      </div>
    </div>
  </div>
</section>
